import { render } from "./ModalMenu.vue?vue&type=template&id=b07c84b6&scoped=true"
import script from "./ModalMenu.vue?vue&type=script&lang=js"
export * from "./ModalMenu.vue?vue&type=script&lang=js"

import "./ModalMenu.vue?vue&type=style&index=0&id=b07c84b6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b07c84b6"]])

export default __exports__